const resolveDefault = <T = any>(module: any): T =>
	(module?.default?.default ?? module?.default ?? module) as T;

export { resolveDefault };
